module.exports = __webpack_public_path__ + "img/cinema4.3a6f2872.jpg";